import React from 'react'
import ReactDOM from 'react-dom/client'
import Card from 'react-bootstrap/Card'
import '../../index.css'
import {useEffect, useState} from 'react'
import axios from 'axios'

import {
  Column,
  Table as ReactTable,
  PaginationState,
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  ColumnDef,
  OnChangeFn,
  flexRender,
} from '@tanstack/react-table'
import DataTable from 'react-data-table-component'
import { useNavigate } from 'react-router-dom';
import {initialQueryState, KTIcon, useDebounce} from '../../../../_metronic/helpers'

export function Banner() {
  const navigate = useNavigate();
  const createItem = () => {
    navigate('/CreateBanner')
  }
  const editItem = (data: any) => {
    console.log(data.original)
    navigate('/EditBanner', {state: data.original});
  };
  const [tableData, setTableData] = useState<any>([])
  //const rerender = React.useReducer(() => ({}), {})[1]
  const API_URL = process.env.REACT_APP_API_URL
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      
      {
        accessorKey: 'title_th',
        header: 'ชื่อกิจกรรม',
        footer: (props) => props.column.id,
        cell: (props) => <p style={{width: '200px'}} >{props.row.original.title_th}</p>,
      },
      {
        accessorKey: 'content_th',
        header: '	รายละเอียดกิจกรรม',
        footer: (props) => props.column.id,
        cell: (props) => <p style={{width: '200px'}} dangerouslySetInnerHTML={{__html: props.row.original.content_th}}></p>,
      },
      {
        accessorKey: 'รูปกิจกรรม',
        header: () => <span>รูปกิจกรรม</span>,
        footer: (props) => props.column.id,
        cell: (props) => <img src={props.row.original.thumbnail_en} width={150} />,
      },
      {
        accessorKey: 'รูปรายละเอียดกิจกรรม',
        header: () => <span>รูปรายละเอียดกิจกรรม</span>,
        footer: (props) => props.column.id,
        cell: (props) => <img src={props.row.original.image_th} width={150} />,
      },
      {
        accessorKey: 'order_item',
        header: 'ลำดับการแสดง',
        footer: (props) => props.column.id,
      },
    ],
    []
  )

  const [data, setData] = React.useState([])
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPage, setTotalPage] = useState(1)
  const [totalRow, setTotalRow] = useState(10)
  const getAPI = async () => {
    const data = await axios.get(`${API_URL}/banner?page=1&limit=10`).then((res) => {
      setTableData(res.data.data)
      setData(() => res.data.data)
      setPage(res.data.page)
      setLimit(res.data.limit)
      setTotalRow(res.data.total)
      setTotalPage(Math.ceil(res.data.total / res.data.limit))
    })
    //return data.data.data
  }

  const refreshAPI = async (page: Number, limit: Number) => {
    const data = await axios
      .get(`${API_URL}/banner?page=${page}&limit=${limit}`)
      .then((res) => {
        setTableData(res.data.data)
        setData(() => res.data.data)
        setTotalRow(res.data.total)
        setTotalPage(Math.ceil(res.data.total / res.data.limit))
      })
  }

  const [searchTerm, setSearchTerm] = useState<string>('')
  const refreshAPISearch = async (search: string) => {
    setSearchTerm(search)
    const data = await axios
      .get(`${API_URL}/banner?page=${1}&limit=${limit}&search=${search}`)
      .then((res) => {
        setTableData(res.data.data)
        setData(() => res.data.data)
        setPage(1)
        setTotalRow(res.data.total)
        setTotalPage(Math.ceil(res.data.total / res.data.limit))
      })
  }
  const table = useReactTable({
    data,
    columns,
    // Pipeline
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    //
    debugTable: true,
  })
  useEffect(
    () => {
      getAPI()
    },
    [] // Only re-call effect if value or delay changes
  )

  return (
    <Card className='table-responsive'>
      <Card.Header>
        <div className='d-flex align-items-center position-relative my-1'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Search user'
            value={searchTerm}
            onChange={(e) => refreshAPISearch(e.target.value)}
          />
        </div>
        {/** add button จุดเพิ่มปุ่ม */}
        <div className='d-flex justify-content-end card-title' data-kt-user-table-toolbar='base'>
          {/*<button type='button' className='btn btn-light-primary me-3'>
            <KTIcon iconName='exit-up' className='fs-2' />
            Export
          </button>*/}

          <button type='button' className='btn btn-primary' onClick={() => {createItem()}}>
            <KTIcon iconName='plus' className='fs-2' />
            Add Banner
          </button>
        </div>
      </Card.Header>
      <table className='table table-striped gy-7 gs-7 '>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th key={header.id} colSpan={header.colSpan}>
                    {header.isPlaceholder ? null : (
                      <div className='fw-bold fs-7 text-gray-1200 border-bottom-2 border-gray-200'>
                        {flexRender(header.column.columnDef.header, header.getContext())}
                      </div>
                    )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  )
                })}
                {/**add button เพิ่มปุ่ม */}
                <td>
                  <button type='button' className='btn btn-primary' onClick={() => {editItem(row)}}>
                    Edit
                  </button>
                  <span> </span>
                  <button type='button' className='btn btn-primary' onClick={() => {}}>
                    Delete
                  </button>
                </td>
                
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className='h-2' />

      <Card.Footer>
        <span className='flex items-center gap-1'>
          <strong>
            Page {page} of {totalPage}
          </strong>
        </span>
        <span className='flex items-center gap-1 mr-3 p-4'>
          | Go to page:
          <input
            type='number'
            defaultValue={page}
            value={page}
            onChange={(e) => {
              if (Number(e.target.value) <= totalPage && Number(e.target.value) > 0) {
                /*const page = e.target.value ? Number(e.target.value) - 1 : 0
                table.setPageIndex(page)*/
                setPage(Number(e.target.value))
                refreshAPI(Number(e.target.value), limit)
              }
            }}
            className='border p-1 rounded w-16'
          />
        </span>
        <span>
          <select
            className='ml-2'
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value))
              refreshAPI(page, Number(e.target.value))
              table.setPageSize(Number(e.target.value))
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </span>
      </Card.Footer>
    </Card>
  )
}
